import React from 'react';

const map = {
  Confirmed: { bg: '#C8E6C9', fg: '#1F5A24', label: 'Confirmed' },
  Held: { bg: '#FFF3E0', fg: '#B26A00', label: 'Held' },
  'Cancelled-Released': { bg: '#EAEAEA', fg: '#555', label: 'Cancelled — Released' },
  CheckedIn: { bg: '#2E7D32', fg: '#FFFFFF', label: 'Checked in' },
  Pending: { bg: '#FFF3E0', fg: '#B26A00', label: 'Pending' },
  Incomplete: { bg: '#FFF3E0', fg: '#B26A00', label: 'Incomplete' },
  Complete: { bg: '#C8E6C9', fg: '#1F5A24', label: 'Complete' },
};

export function StatusBadge({ status, checkedIn, testid }) {
  let key = status;
  if (checkedIn) key = 'CheckedIn';
  const cfg = map[key] || { bg: '#EEE', fg: '#333', label: String(status || '—') };
  const isTicked = key === 'CheckedIn';
  return (
    <span
      data-testid={testid || `status-${String(key).toLowerCase()}`}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold"
      style={{ backgroundColor: cfg.bg, color: cfg.fg }}
    >
      {isTicked && (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      )}
      {cfg.label}
    </span>
  );
}
